import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../layout/theme-next/provider';
import Colors from '../../../../layout/theme/utils/colors';

export const styles = makeStyles((theme: NextTheme) =>
  createStyles({
    typographyBold: {
      fontSize: '14px',
      fontWeight: 600,
      letterSpacing: 0,
    },
    margin5: {
      marginRight: '5px',
    },
    link: {
      color: Colors.black,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    [theme.media.mobile]: {
      link: {
        pointerEvents: 'none',
      },
      typographyBold: {
        whiteSpace: 'normal',
      },
    },
  }),
);
